import React from "react";
import { makeStyles } from "@material-ui/core";
import ReportsPicker from "ReportsPicker";
import ReportsCard from "ReportsCard";

const useStyles = makeStyles(theme => ({
  card: {
    position: "relative",
    overflow: "hidden",
  },
}));

const ReportsPickerCard = ({
  label,
  values,
  selectedValue,
  onValueChange,
  includeAll = false,
  ...props
}) => {
  const classes = useStyles();

  return (
    <ReportsCard cardLabel={label} className={classes.card}>
      <ReportsPicker
        selectedValue={selectedValue}
        onSelectedChange={onValueChange}
        values={values}
        includeAll={includeAll}
      />
      {props.children}
    </ReportsCard>
  );
};

export default ReportsPickerCard;
